import { Order } from '../../order';
import { ExternalEntityType } from '../entity';

export namespace BusinessCentral {
  export const isPurchaseOrder = (order?: Order) =>
    order && order.externalIdentifier?.type === ExternalEntityType.bc_purchase_order;
  export const isItemJournal = (order?: Order) =>
    order && order.externalIdentifier?.type === ExternalEntityType.bc_item_journal;
  export const isJob = (order?: Order) => order && order.externalIdentifier?.type === ExternalEntityType.bc_job;
  export const isElterosInvoice = (order?: Order) =>
    order && order.externalIdentifier?.type === ExternalEntityType.elteros_custom_invoice;
}
